import singleIndex from 'instantsearch.js/es/lib/stateMappings/singleIndex';

const primitiveKeys = ['configure', 'menu', 'numericMenu', 'ratingMenu', 'toggle', 'range', 'geoSearch', 'hierarchicalMenu'];
const arrayKeys = ['refinementList'];
const mergeKeys = [...primitiveKeys, ...arrayKeys];

function mergeUiState (base, values, depth = Infinity) {
  const merged = { ...base, ...values };

  for (const index in base) {
    const baseIndex = base[index];
    const mergedIndex = { ...baseIndex, ...merged[index] }

    for (const key of depth > 1 ? mergeKeys : []) {
      mergedIndex[key] = { ...baseIndex[key], ...mergedIndex[key] };
    }

    for (const key of depth > 2 ? arrayKeys : []) {
      const baseEntries = baseIndex[key];
      const mergedEntries = { ...baseEntries, ...mergedIndex[key] };

      for (const entry in baseEntries) {
        mergedEntries[entry] = [...baseEntries[entry], ...mergedEntries[entry]];
      }

      mergedIndex[key] = mergedEntries;
    }

    merged[index] = mergedIndex;
  }

  return merged;
}

function solrParamsToInstantSearch ({ q, fq } = {}) {
  const transformed = {};
  const facetQueries = fq
    ? (typeof fq === "string" ? [fq] : fq)
    : [];

  if (q) transformed.query = q;

  for (const facetQuery of facetQueries) {
    const [facet, filter] = facetQuery.split(':');

    switch (facet) {
      case 'Lieferbar':
        transformed.refinementList = transformed.refinementList ?? {};
        transformed.refinementList.availability = [
          filter == '"Auf Lager"'
            ? "Sofort Lieferbar"
            : filter == '"In 1 - 2 Wochen"'
              ? "Lieferzeit 4-7 Tage"
              : filter == '"In 1 - 2 Wochen"'
                ? "Lieferzeit 1-2 Wochen"
                : filter == '"Vorbestellung"'
                  ? "Vorbestellung"
                  : filter == '"Ausverkauft"'
                    ? "Ausverkauft"
                    : "",
        ];
        break;
      case 'Zustand':
        transformed.refinementList = transformed.refinementList ?? {};
        transformed.refinementList.condition = [filter];
        break;
      case 'Kategorie':
        transformed.hierarchicalMenu = transformed.hierarchicalMenu ?? {};
        transformed.hierarchicalMenu['category.lvl1'] = [filter.replace(/^"(.*)"$/, "$1")];
        break;
      case 'Unterkategorie':
        transformed.refinementList = transformed.refinementList ?? {};
        transformed.refinementList.type = [filter];
        break;
      case 'Zusatz':
        transformed.refinementList = transformed.refinementList ?? {};
        transformed.refinementList['items.packaging'] = [filter];
        break;
      case 'Genre':
        transformed.refinementList = transformed.refinementList ?? {};
        transformed.refinementList.genre = [filter];
        break;
      case 'USK':
        transformed.refinementList = transformed.refinementList ?? {};
        transformed.refinementList.usk = [`ab ${filter}`];
        break;
    }
  }

  return transformed;
}

export default function customRouteStateMapping (index, initialUiState = {}, filters = '') {
  const { pathname } = new URL(window.location.href);
  const routeMapping = singleIndex(index);
  const filterMap = filters.split(',').reduce((acc, filter) => {
    if (!filter) return acc;

    const [key, value] = filter.split(':');
    acc[key] = value?.replaceAll('`', '');
    return acc;
  }, {});
  const categoryTree = filterMap.category_pages ? filterMap.category_pages.split(" > ") : [];
  const pathTree = pathname.split("/").slice(1);
  const categoryPaths = Object.fromEntries(
    categoryTree.map((category, i) => [category, pathTree[i]])
  );

  if (filterMap.category_pages) {
    initialUiState = mergeUiState(initialUiState, {
      [index]: {
        hierarchicalMenu: {
          'category.lvl1': [filterMap.category_pages]
        }
      }
    });
  }

  return {
    stateToRoute (uiState) {
      return routeMapping.stateToRoute(mergeUiState(initialUiState, uiState, 2));
    },
    routeToState (routeState = {}) {
      const currentUiState = routeMapping.routeToState(
        'q' in routeState || 'fq' in routeState
          ? solrParamsToInstantSearch(routeState)
          : routeState
      );
      return mergeUiState(initialUiState, currentUiState);
    },
    extendUIState (uiState) {
      return mergeUiState(initialUiState, uiState);
    },
    transformBreadcrumbItem (item) {
      if (!item.value || !initialUiState?.[index]?.hierarchicalMenu?.['category.lvl1']) return item;

      return {
        ...item,
        categoryUrl: filterMap.category_pages.includes(item.value)
          ? "/" + item.value.split(" > ").map((category) => categoryPaths[category]).join("/") + "/"
          : undefined
      };
    },
    solrParamsToInstantSearch,
    mergeUiState,
  };
}